function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b5b4ae20\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PCS05_ResponseDisplay.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PCS05_ResponseDisplay.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b5b4ae20\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PCS05_ResponseDisplay.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5b4ae20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/ulip/PCS05_ResponseDisplay.vue
// module id = 2275
// module chunks = 0